import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";

import {
  Screen1,
  VidReviewsTop,
  Quote,
  About,
  Skills,
  HowTo,
  BlocksStructure,
  AdvanceAdvantages,
  ReviewsBottom,
  Cost,
  AdvancePeople,
  AdvanceFounder,
  AdvanceLicenses
} from "../../../components/LandingTemplates/kak_uchitya_doma";

const TITLE = 'Как учиться дома | Центр образовательных технологий Advance';
const DESCRIPTION = 'Как учиться дома Индивидуальные занятия онлайн для быстрого обучения детей';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = (
  { widget=(<GetCourseWidget hash={'887e0b1e28edc3bc179afb1654363db53be1a798'} id={'177792'} />) }
) => (
  <DefaultLayout
    style={{ "body": { maxWidth: "100%" } }}
  >
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 widget={widget}/>
      <VidReviewsTop/>
      <Quote/>
      <About/>
      <Skills/>
      <HowTo/>
      <BlocksStructure/>
      <AdvancePeople/>
      <ReviewsBottom/>
      <Cost widget={widget}/>
      <AdvanceAdvantages/>
      <AdvanceFounder/>
      <AdvanceLicenses/>
    </main>

    <FooterFull/>
  </DefaultLayout>
);

export default Page;
